import api from "../../services/api/axios";

export async function fetchNotifications(params = {}) {
  const response = await api.get("/notifications", { params });
  return response.data || [];
}

export async function fetchUnreadCount() {
  const response = await api.get("/notifications/unread-count");
  return Number(response.data?.unread_count || 0);
}

export async function createNotification(payload) {
  const response = await api.post("/notifications", payload);
  return response.data;
}

export async function markNotificationRead(notificationId) {
  const response = await api.put(`/notifications/${notificationId}/read`);
  return response.data;
}

export async function markAllNotificationsRead() {
  const response = await api.put("/notifications/read-all");
  return response.data;
}

export async function deactivateNotification(notificationId) {
  await api.delete(`/notifications/${notificationId}`);
}
